<template>
  <div v-if="store.filters.ctg8p1 && store.filters.ctg8p1.length > 0" class="filter d-flex flex-column">
    <h5 class="margin-0">
      {{ t('vehicle-category') }}
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <div
      v-for="category in store.filters.ctg8p1"
      :key="category.id"
      class="collapse show"
      id="ctg8p1"
    >
      <div class="info d-flex align-items-center category">
        <div :class="['icon', 'icon-' + category]"></div>
        <!-- Odstępy robi `gap` wiersza, nie klasy marginesów Bootstrapa —
             inaczej kontrolka miałaby po 20 px z boków, a numer 12 px. -->
        <input-checkbox
          :field-name="category.id"
          field-value=""
          :checkedCondition="true"
          @clicked="setFilter(category)"
        />
        <p class="margin-0">{{ category }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import InputCheckbox from "../InputCheckbox.vue";

export default {
  props: {
    store: { required: true },
  },
  components: { InputCheckbox },
  name: "VehicleCategoriesFilterView",
  methods: {
    setFilter(index) {
      this.store.addItem(
        "VehicleCategories",
        this.store.vehicleCategories.indexOf(index)
      );
    },
    removeFilter() {
      this.store.removeItem("ctg8p1");
    },
  },
};
</script>
<style scoped>
.filter {
  width: 100%;
}

.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}
.filter .collapse {
  margin: 1px 0;
}
/* .filter .collapse:nth-of-type(1) {
  margin-top: 10px;
}
.filter .collapse:last-child {
  margin-bottom: 10px;
} */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
}


.info p {
  font-size: var(--font-size-sm);
  /* margin: 0; */
}

/* Wiersz kategorii — te same metryki co w pozostałych panelach podsumowania
   filtrów (`DateRangeFilterView`, `ResolutionFilterView`, `StatNameFilterView`):
   `--spacing-md` w pionie, `--spacing-lg` w poziomie. Odstępy między ikoną,
   kontrolką i numerem robi `gap`, nie marginesy na elementach. */
.info.category {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) var(--spacing-lg);
  font-size: var(--font-size-sm);
  border-bottom: 1px solid var(--border-subtle);
}

/* Globalne `.icon` (viver-style.css) ma `position: absolute` — tego wymaga
   pływający przycisk „do góry", gdzie `<i class="icon">` bez tego nie przyjmuje
   wymiarów. Tutaj ikona jest normalnym elementem wiersza, więc wracamy do
   układu w toku: bez tego wypada z flexa, siada na starcie wiersza, a kontrolka
   i numer kategorii wchodzą pod nią (stąd nakładające się ikony i cyfry). */
.info.category .icon {
  position: static;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}

.info.category :deep(.container),
.info.category :deep(.container2) {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  flex: 0 0 18px;
  aspect-ratio: 1 / 1;
}

.info.category :deep(.checkmark),
.info.category :deep(.vio) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

/* .icon {
  margin: 5px;
  height: 15px;
  width: 35px;
  left: 55px;
} */

/*
.icon-2 {
  background: url("../../assets/icons/kategoria-2.png") no-repeat left top;
}
.icon-3 {
  background: url("../../assets/icons/kategoria-3.png") no-repeat left top;
}
.icon-5 {
  background: url("../../assets/icons/kategoria-5.png") no-repeat left top;
}
.icon-7 {
  background: url("../../assets/icons/kategoria-7.png") no-repeat left top;
}
.icon-8 {
  background: url("../../assets/icons/kategoria-8.png") no-repeat left top;
}
.icon-9 {
  background: url("../../assets/icons/kategoria-9.png") no-repeat left top;
}
.icon-10 {
  background: url("../../assets/icons/kategoria-10.png") no-repeat left top;
  left: 60px;
}
.icon-11 {
  background: url("../../assets/icons/kategoria-11.png") no-repeat left top;
  left: 60px;
} */
</style>
